import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Applications from './pages/Applications';
import Security from './pages/Security';
import Users from './pages/Users';
import Admins from './pages/Admins';
import Login from './pages/Login';

const ProtectedRoute = ({ children }) => {
    const adminUser = localStorage.getItem('adminUser');
    const location = useLocation();

    if (!adminUser) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={
                    <ProtectedRoute>
                        <MainLayout />
                    </ProtectedRoute>
                }>
                    <Route index element={<Navigate to="/applications" replace />} />
                    <Route path="applications" element={<Applications />} />
                    <Route path="users" element={<Users />} />
                    <Route path="security" element={<Security />} />
                    <Route path="admins" element={<Admins />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
